import { render, staticRenderFns } from "./MessageFileWrapper.vue?vue&type=template&id=2b1dd686"
import script from "./MessageFileWrapper.vue?vue&type=script&lang=ts"
export * from "./MessageFileWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports